import React from 'react';
import { 
  Sprout, 
  TrendingUp, 
  CheckCircle2 
} from 'lucide-react';

const EquityFundSelectionFramework = () => {
  const frameworks = [
    {
      icon: Sprout,
      title: "Roots: Strong Fundamentals",
      description: "We look for companies with solid financial foundations",
      features: [
        "Companies with low debt and high ROE",
        "Sustainable business models with robust financials",
        "Promoter skin-in-the-game through meaningful shareholding"
      ],
      bgColor: "from-[#113262] to-[#1C52A0]"
    },
    {
      icon: TrendingUp,
      title: "Wings: Growth Visibility",
      description: "We prioritize businesses with proven growth trajectories",
      features: [
        "Consistent profit and revenue growth",
        "Positive, predictable free cash flows",
        "Resilience during downturns with faster recovery rates"
      ],
      bgColor: "from-[#955C0A] to-[#F49611]"
    }
  ];

  return (
    <div className="bg-white relative">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-[#E8EEF6]/30">
        <div className="absolute inset-0" style={{
          backgroundImage: 'radial-gradient(#113262 1px, transparent 1px)',
          backgroundSize: '20px 20px',
          opacity: 0.1
        }} />
      </div>

      <div className="container relative z-10 max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <div className="w-12 h-0.5 bg-[#F49611] mx-auto mb-4" />
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">
            How We Select Equity Mutual Funds Using the Three Lenses
          </h2>
          <p className="text-gray-600">
            Here's how the <strong>Three-Lens Framework</strong> comes together when we evaluate equity mutual funds
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {frameworks.map((framework, index) => (
            <div key={index} className="relative group">
              {/* Card */}
              <div className={`bg-gradient-to-br ${framework.bgColor} rounded-lg p-8 text-white h-full`}>
                <div className="w-16 h-16 rounded-xl bg-white/10 flex items-center justify-center mb-6">
                  <framework.icon className="w-8 h-8 text-white" />
                </div>

                <h3 className="text-2xl font-bold mb-4">{framework.title}</h3>
                <p className="text-white/80 mb-6">{framework.description}</p>

                <div className="space-y-3">
                  {framework.features.map((feature, idx) => (
                    <div key={idx} className="flex items-center gap-3">
                      <CheckCircle2 className="w-5 h-5 text-white" />
                      <span className="text-white/90">{feature}</span>
                    </div>
                  ))}
                </div>
              </div>  
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EquityFundSelectionFramework;